import React from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import moment from 'moment';

export default React.createClass({
	getInitialState: function(){
		return {
			isValid: true,
			isAfterValidate: false,
			value: this.props.value != undefined ? this.props.value : "",
			validationError: null // No initial server errors
		};
	},
	/*componentWillReceiveProps: function(nextProps){
		console.log(nextProps.value + ' -- ' + this.state.value);
		if(nextProps.value != this.state.value)
			this.setState({
				value: this.state.value
			});
	},*/
	componentWillMount: function(){
		if(this.props.name && this.props.attachToForm)
			this.props.attachToForm(this);
	},
	componentWillUnmount: function(){
		if(this.props.name)
			this.props.detachFromForm(this);
	},
	setValue: function(event){
		this.setState({
			value: event.target.value
		}, function () {
			this.props.validate(this);

			if(this.props.change)
				this.props.changeField(this.props.index, this.props.change);
		}.bind(this));
	},
	setValueSelect: function(event){
		this.setState({
			value:  event ? event.value : ''
		}, function () {
			this.props.validate(this);

			if(this.props.change)
				this.props.changeField(this.props.index, this.props.change);
		}.bind(this));
	},
	setValueDatePicker: function(value) {
		this.setState({
			value: value
		}, function () {
			this.props.validate(this);

			if(this.props.change)
				this.props.changeField(this.props.index, this.props.change);
		}.bind(this));
	},
	setValueCheckbox: function(event){
		this.setState({
			value: event.target.checked ? 1 : 0
		}, function () {
			this.props.validate(this);

			if(this.props.change)
				this.props.changeField(this.props.index, this.props.change);
		}.bind(this));
	},
	setValueHidden: function(value) {
		this.setState({
			value: value
		}, function () {
			this.props.validate(this);
		}.bind(this));
	},
	validationState(valid) {
		if (this.state.isAfterValidate)
		{
			if (valid)
				return 'success';
			else
				return 'error';
		}

		return '';
	},
	text: function(markAsValid, className){
		let input =
			<input
				type="text"
				onChange={this.setValue}
				onKeyPress={this.props.keyPress ? this.props.keyPress : ''}
				name={this.props.name}
				value={this.state.value}
				placeholder={this.props.placeholder ? this.props.placeholder : ''}
				maxLength={this.props.maxlength ? this.props.maxlength : ''}
				autoFocus={this.props.autofocus != undefined ? this.props.autofocus : false}
			/>
		return  (<div className={"field "+this.validationState(markAsValid)+(this.props.wprapClass ? " "+this.props.wprapClass : '')}>
					{this.generateInputContent(input)}
					{markAsValid ? null :
						<div className="ui red pointing label">
							{this.state.validationError}
						</div>
					}
				</div>);
	},
	hidden: function(markAsValid, className){
		let input =
			<input
				type="hidden"
				onChange={this.setValue}
				name={this.props.name}
				value={this.state.value}
			/>
		return  (<div className={"field "+this.validationState(markAsValid)}>
					{this.generateInputContent(input)}
					{markAsValid ? null :
						<div className="ui red pointing label">
							{this.state.validationError}
						</div>
					}
				</div>);
	},
	select: function(markAsValid, className){
		let select;
		if(this.props.loadOptions == undefined)
			select =
				<Select
				    value={this.state.value}
				    options={this.props.options}
				    onChange={this.setValueSelect}
				    placeholder={this.props.placeholder}
				    autofocus={true}
						backspaceRemoves={false}
						style={this.props.style}
				/>
		else{
			select =
				<Select.Async
				    value={this.state.value}
				    onChange={this.setValueSelect}
				    loadOptions={this.props.loadOptions}
				/>
		}

		return  (<div className={"field "+this.validationState(markAsValid)+(this.props.wprapClass ? " "+this.props.wprapClass : '')}>
					{this.generateInputContent(select)}
					{markAsValid ? null :
						<div className="ui red pointing label">
							{this.state.validationError}
						</div>
					}
				</div>);
	},
	datepicker: function(markAsValid, className){
		let datepicker, date, props = [];
		moment.locale('pl');
		moment().format('YYYY-MM-DD')
		if(this.state.value == undefined || this.state.value == '')
		{
			this.state.value = date = '';
		}
		else
			date = moment(this.state.value);

		datepicker = (
			<DatePicker 
				dateFormat="YYYY-MM-DD" 
				selected={date} 
				onChange={this.setValueDatePicker} 
				minDate={this.props.minDate ? this.props.minDate : false}
			/>
		)

		return  (<div className={"field "+this.validationState(markAsValid)+(this.props.wprapClass ? " "+this.props.wprapClass : '')}>
					{this.generateInputContent(datepicker)}
					{markAsValid ? null :
						<div className="ui red pointing label">
							{this.state.validationError}
						</div>
					}
				</div>);
	},
	checkbox: function(markAsValid, className){
		return(
			<div className="ui checkbox">
				<input
					type="checkbox"
					onChange={this.setValueCheckbox}
					name={this.props.name}
					value={this.state.value}
					checked={this.state.value}
				/>
				<label></label>
			</div>
		);
	},
	password: function(markAsValid, className){
		let input =
			<input
				type="password"
				onChange={this.setValue}
				name={this.props.name}
				value={this.state.value}
				placeholder={this.props.placeholder ? this.props.placeholder : ''}
			/>
		return  (<div className={"field "+this.validationState(markAsValid)}>
					{this.generateInputContent(input)}
					{markAsValid ? null :
						<div className="ui red pointing label">
							{this.state.validationError}
						</div>
					}
				</div>);
	},
	textarea: function(markAsValid, className){
		let textarea =
			<textarea
				onChange={this.setValue}
				name={this.props.name}
				value={this.state.value}
				placeholder={this.props.placeholder ? this.props.placeholder : ''}
				rows={this.props.rows ? this.props.rows : '3'}
			/>
		return  (<div className={"field "+this.validationState(markAsValid)+(this.props.wprapClass ? " "+this.props.wprapClass : '')}>
					{this.generateInputContent(textarea)}
					{markAsValid ? null :
						<div className="ui red pointing label">
							{this.state.validationError}
						</div>
					}
				</div>);
	},
	generateInputContent(formElement) {
		let label = this.generateLabel();

		return (
			<div className={this.props.icon ? 'ui left icon input' : ''}>
				{this.props.icon ? <i className={this.props.icon}></i> : ''}
				{label}
				{formElement}
			</div>
		);

	},
	generateLabel()
	{
		if(this.props.title)
			return <label className="control-label label-class">{this.props.title}</label>
		else
			return '';
	},
	submit: function(){
		return (<input className={this.props.color+" ui button"} value={this.props.title} type="submit" />);
	},
	render: function(){
		var markAsValid = this.state.isValid,
			markAsRequired = this.props.required,
			className = '';

		if(markAsRequired)
			var className = 'required ';

		if (!markAsValid) {
			className += 'error';
		}else if(this.state.isAfterValidate){
			className += 'success';
		}
		return this[this.props.type](markAsValid, className);
	}
});



/** WEBPACK FOOTER **
 ** ./js/components/form/ui-semantic-form-elements.js
 **/